module.exports = __webpack_public_path__ + "static/media/pray.602f7b13.svg";